<template>

   <div class="app-label-wrapper">
       <label class="app-label">
            <slot/>
       </label>
   </div>

</template>

<script>

    export default {
        props: {

        },
    }

</script>

<style lang="scss" scoped>

    .app-label-wrapper {
        display: flex;
        align-items: start;
        margin-bottom: 20px;

        label {
            color: rgba(0, 0, 0, 0.60);
            font-size: 18px;
            font-weight: $font-normal;
        }

    }

</style>
